import React from "react";
// State
import { useGetUsersQuery } from "../app/apiSlice";
// Components
import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe";
import BooksSection from "../components/books/BooksSection";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import BackToTop from "../components/BackToTop";
import GalleryPreview from "../components/Gallery/GalleryPreview";
import ScrollReveal from "../components/ScrollReveal";

// Config
import { moreInfo, booksData, heroSubtitle } from "../config";
import { mainSections } from "../config/sections";
// Utils
import { updateTitle } from "../utils";

const Home = () => {
  const { data: userData } = useGetUsersQuery();

  React.useEffect(() => {
    if (userData) {
      updateTitle(`${userData.name} | Portfolio`);
    }
  }, [userData]);

  if (!userData) return null;

  const renderSection = (section) => {
    switch (section.component) {
      case "Hero":
        return <Hero name={userData.name} subtitle={heroSubtitle} avatar_url={userData.avatar_url} />;
      case "AboutMe":
        return (
          <AboutMe
            avatar_url={userData.avatar_url}
            moreInfo={moreInfo}
          />
        );
      case "GalleryPreview":
        return <GalleryPreview />;
      case "Projects":
        return <Projects />;
      case "BooksSection":
        return <BooksSection books={booksData} />;
      case "Skills":
        return <Skills />;
      case "Contact":
        return <Contact />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderSection(mainSections[0])} {/* Hero is always first */}
      <main>
        {mainSections.slice(1).map((section) => (
          <ScrollReveal key={section.id}>
            {renderSection(section)}
          </ScrollReveal>
        ))}
      </main>
      <BackToTop />
    </>
  );
};

export default Home;
